const angular = require('angular');

module.exports = function ($rootScope, $state, shopperService, loginService, pageMetadataService, memoScroll, moveFocus) {
    function promptForLogin(event, toState, toParams) {
        event.preventDefault();
        loginService.promptForLogin(loginService.LoginToContinueMessage, toState, toParams);
    }

    $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {
        if (fromState.data && fromState.data.onAuthReturnToState) {
            $rootScope.onAuthRedirectedState = $state.get(fromState.data.onAuthReturnToState);
            $rootScope.onAuthRedirectedStateParams = {};
        } else {
            $rootScope.onAuthRedirectedState = fromState;
            $rootScope.onAuthRedirectedStateParams = fromParams;
        }

        if (toState.data && toState.data.authenticate && shopperService.IsGuest) {
            if (angular.isArray(toState.data.authenticate)) {
                $state.shouldAuthenticate(toState, toParams).then((requiresLogin) => {
                    if (requiresLogin) {
                        promptForLogin(event, toState, toParams);
                    }
                });
            } else {
                promptForLogin(event, toState, toParams);
            }
        }
    });

    $rootScope.$on('$stateChangeSuccess', () => {
        pageMetadataService.useCurrentStateMetadata();

        moveFocus('#body-container', true);
        moveFocus(() => $('#center-panel h1').filter(':first'), false);
    });

    $rootScope.$on('$locationChangeStart', (event, newUrl, oldUrl) => {
        memoScroll.rememberScrollPosition(oldUrl);
    });

    $rootScope.$on('$locationChangeSuccess', (event, newUrl) => {
        if (!($state.current && $state.current.data && $state.current.data.optOutOfScrollRestore)) {
            memoScroll.restoreScrollPosition(newUrl);
        }
    });
};



// WEBPACK FOOTER //
// ./src/configuration/startup.js